module.exports = {
  // 活动时间线
  timeLine: {
    launch: {
      start: new Date('2025/10/31 00:00:00 GMT+8').getTime()
    },
    member: {
      start: new Date('2025/10/31 00:00:00 GMT+8').getTime()
    }
  }
};